
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cooking",
      function () {
        return require("private-next-pages/cooking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cooking"])
      });
    }
  